<template>
  <div>
    <div id="age-select" class="panel mb-xs-4 active">
      <div class="panel-content px-xs-4 px-md-0 pt-xs-4 pt-md-80">
        <h1 v-html="$getString('GLOBAL_SIGNS_OF_A_MOTOR_DELAY')"></h1>
        <div class="bottom-hr bg-sma-turquoise mb-xs-4"></div>

        <h2 v-html="$getString('AGE_HOW_OLD')"></h2>
        <p class="smaller fg-sma-black-75" v-html="$getString('AGE_SELECT_ALL_CONCERNED')"></p>

        <div class="age-selection">
          <div
            v-for="(group, index) in this.$store.getters.ageGroups"
            :key="index"
            :class="[ 'br-1', { active: age === index } ]"
            @click="onSetAge(index)"
            v-html="group.label"
          ></div>
        </div>
      </div>
    </div>

    <div class="questionnaire-buttons container text-centered">
      <div class="tool-button previous mx-xs-2" @click="onPrevious" v-html="$getString('GLOBAL_BUTTON_BACK')"></div>
      <div :class="[ 'tool-button next mx-xs-2', { disabled: !next } ]" @click="onNext" v-html="$getString('GLOBAL_BUTTON_NEXT')"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StageAgeSelect',
  props: {
    stage: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      age: -1,
      next: false,

      handlers: [],
    }
  },
  methods: {
    onPrevious() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_Back`,
      } });

      this.$emit('action', { type: 'decrement-page' });
      this.$emit('action', { type: 'goto-stage', data: 'introduction' });
    },
    onNext() {
      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_Continue`,
      } });

      this.$emit('action', { type: 'increment-page' });
      this.$emit('action', { type: 'goto-stage', data: 'symptoms' });
    },

    onSetAge(age) {
      this.age = age;
      this.$emit('action', { type: 'reset' }); // Clear stored data when switching age groups
      this.$store.commit('SetData', { key: 'age', value: this.age });
      this.next = true;

      this.$emit('action', { type: 'log-analytics', data: {
        "category": 'Internal_link_click',
        "action": '/',
        "label": `{page_label}_{age}`,
      } });
    },
  },
  mounted() {
    this.age = this.$store.getters.dataKey('age');
    this.next = this.age > -1;
  },
}
</script>
